/** Persisted browse filter state (localStorage). */
export const LISTING_FILTER_STATE_KEY = 'listing_filter_state';
/** @deprecated Read fallback only — pre-rename storage key. */
export const LEGACY_MOTOR_FILTER_STATE_KEY = 'motor_filter_state';

/** Session-scoped filter snapshot when navigating to item detail. */
export const LISTING_FILTER_SESSION_KEY = 'listing_filter_state';
/** @deprecated Read/remove fallback only. */
export const LEGACY_MOTOR_FILTER_SESSION_KEY = 'motor_filter_state';

/** Add-listing form draft values cleared on category navigation. */
export const LISTING_FORM_VALUES_KEY = 'listing_form_values';
/** @deprecated Read/remove fallback only. */
export const LEGACY_MOTOR_FORM_VALUES_KEY = 'motor_form_values';

export const LISTING_UI_STATE_KEY = 'listing_ui_state';
/** @deprecated Read fallback only. */
export const LEGACY_MOTOR_UI_STATE_KEY = 'motor_ui_state';
